var Locales;
(function (Locales) {
    Locales["en"] = "en-us";
    Locales["fr"] = "fr";
    Locales["es"] = "es";
    Locales["ja"] = "ja";
    Locales["it"] = "it";
    Locales["pt"] = "pt";
})(Locales || (Locales = {}));

export { Locales };
